export default __webpack_public_path__ + "static/media/redington-white-logo.29cd6043.png";